import {Auth, API} from "aws-amplify";

let apiName = process.env.REACT_APP_APINAME;
let path = "";
let requestBody = "";

class ReportService {

    async allTransactionReport(params = {}, callback) {

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;

        path = process.env.REACT_APP_URL_ALLTRANSACTIONREPORT;
        requestBody = {
            body: {
                ...params
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(data => {
            return callback(null, data);
        }).catch(error => {
            return callback(error, null);
        });
    }

    async insuranceReport(params = {}, callback) {

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;

        path = process.env.REACT_APP_URL_INSURENCEREPORT;
        requestBody = {
            body: {
                ...params,
                option: 0,
                insureId: 0
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(data => {
            console.debug("insData:",data);
            return callback(null, data);
        }).catch(error => {
            return callback(error, null);
        });
    }

    async getInsuranceDetailsById(id, callback) {

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;

        path = process.env.REACT_APP_URL_INSURENCEREPORT;
        requestBody = {
            body: {
                pageSize: 10,
                page: 0,
                sorted: [],
                filtered: [],
                state: 1,
                option: 1,
                insureId: id
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(response => {
            return callback(null, response);
        }).catch(error => {
            console.log(error);
            return callback(error, null);
        });
    }

    async adminGetAllTransaction(params, callback){

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;

        path = process.env.REACT_APP_URL_ALLTRANSACTION_REPORT;
        requestBody = {
            body: {
                pageSize: 100,
                page: 0,
                sorted: [],
                filtered: [],
                ...params
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(response => {
            return callback(null, response);
        }).catch(error => {
            console.log(error);
            return callback(error, null);
        });
    }

}

export default ReportService;